import React from 'react';
import AccordionFilter from '@/components/ui/AccordionFilter';
import { FilterOption } from './FilterOption';
import type { FileFilters } from '../../../../../types/file.types';
import { styles } from '../styles';

interface FilterGroupProps {
  title: string;
  options: Array<{
    id: FileFilters;
    label: string;
  }>;
  selectedFilters: FileFilters[];
  onToggleFilter: (filter: FileFilters) => void;
}

export const FilterGroup: React.FC<FilterGroupProps> = ({
  title,
  options,
  selectedFilters,
  onToggleFilter,
}) => {
  return (
    <AccordionFilter
      title={title}
      content={
        <div className={styles.groupContent}>
          {options.map((option) => (
            <div key={option.id} className={styles.groupOption}>
              <FilterOption
                id={option.id}
                label={option.label}
                checked={selectedFilters.includes(option.id)}
                onChange={() => onToggleFilter(option.id)}
              />
            </div>
          ))}
        </div>
      }
    />
  );
};
